import type {SetStateAction} from 'react'
import insertToTextArea from './insertTextArea'
import {postUploadImage} from '../../apis/image/postUploadImage'
import {AnnounceImageType} from '../../pages/post/announcement/AnnounceCreate'

const onImagePasted = async (
    dataTransfer: DataTransfer,
    setMarkdown: (value: SetStateAction<string | undefined>) => void,
) => {
    const files: File[] = []
    for (let index = 0; index < dataTransfer.items.length; index += 1) {
        const file = dataTransfer.files.item(index)

        if (file) {
            files.push(file)
        }
    }

    const image: AnnounceImageType[] = []
    await Promise.all(
        files.map(async file => {
            const url = (await postUploadImage(file, false, true)).image_url
            const markdown = `![${file.name}](${url})`
            const insertedMarkdown = insertToTextArea(markdown + '\n')
            if (!insertedMarkdown) {
                return
            }
            setMarkdown(insertedMarkdown)
            image.push({markdown: markdown, url: url})
        }),
    )
    return image
}

export default onImagePasted
